import { render, staticRenderFns } from "./create-project-activity-progress-modal.vue?vue&type=template&id=4b52af48&scoped=true"
import script from "./create-project-activity-progress-modal.vue?vue&type=script&lang=js"
export * from "./create-project-activity-progress-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52af48",
  null
  
)

export default component.exports